import { submitProviderDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const submitProviderCallable = getCallable(submitProviderDefinition);
